import { Vue, Component } from 'vue-property-decorator';
import '@/registerVuePlugins';

import { default as WorkflowTemplatesPage } from './Components/WorkflowTemplatesPage.vue';

@Component({
  name: 'workflow-template-component',
  components: { WorkflowTemplatesPage }
})
class WorkflowTemplateComponent extends Vue {
  public verificationToken: string = '';

  public async mounted() {
    this.verificationToken = await this.$verificationToken();
  }
}

new WorkflowTemplateComponent()
  .$mount('#workflow-template-view');